import type { FC } from "react";

import classNames from "classnames";

import styles from "./ProgressBarMilestone.module.scss";

type ProgressBarMilestoneProps = {
  milestoneText: React.ReactNode;
  isDone?: boolean;
  className?: string;
  isLast?: boolean;
};

export const ProgressBarMilestone: FC<ProgressBarMilestoneProps> = ({ milestoneText, isDone, className, isLast }) => {
  return (
    <div
      data-testid="progressBarMilestone"
      className={classNames(styles.progressBarMilestonesItem, className, {
        [styles.progressBarMilestonesItemDone]: isDone,
        [styles.progressBarMilestonesItemIsLast]: isLast,
      })}
    >
      {milestoneText}
    </div>
  );
};
